export default __webpack_public_path__ + "static/media/dev-profile-pic.9c1f87b2.png";